import NameWithTitle from "../UI/NameWithTitle";
import i18n from "i18n";

const NameWithPrefixInput = ({ label = i18n.t("common:name"), placeholder = i18n.t("common:name"), id = null, required = true, maxLength = false }) => {
  let attr = {};
  if (maxLength) attr["maxLength"] = 50;
  return (
  <NameWithTitle
    label={label}
    placeholder={placeholder}
    type="text"
    id={`${id ? id + "_" : ""}name`}
    autoComplete={`${id ? id + " " : ""}name`}
    required={required}
    attr={attr}
  />
)};
export default NameWithPrefixInput;